// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3ERsR","inner":"Footer_inner__3On2r"};